var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['w-100 border-bottom', { 'sticky-top': _vm.isMobile }],attrs:{"id":"navbar-top-container"}},[_c('b-navbar',{attrs:{"toggleable":"md","type":"light","variant":"white"}},[_c('div',{class:[
        'd-flex align-items-center w-100 justify-content-center',
        { container: !_vm.isMobile }
      ]},[_c('b-navbar-brand',{staticClass:"text-center flex-grow-0 mr-0",attrs:{"href":"#"}},[_c('NavBrand')],1)],1)]),_c('CartPromptModal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }